import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { FC, ReactNode, useMemo } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { AccountStatusVariant } from "../constants";
import { cx } from "shared/utils";
import { HugeiconsIcon } from "@hugeicons/react";

type Props = {
  status: AccountStatusVariant;
  size?: BadgeSize;
  className?: string;
};

export const AccountStatusBadge: FC<Props> = ({
  status,
  size = BadgeSize.SM,
  className
}) => {
  const {
    variant,
    icon,
    title
  }: {
    variant: BadgeVariant;
    icon?: ReactNode;
    title?: string;
  } = useMemo(() => {
    switch (status) {
      case AccountStatusVariant.Pending:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending",
          icon: (
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size={12}
              color="#DE9306"
            />
          )
        };
      case AccountStatusVariant.NeedToReport:
        return {
          variant: BadgeVariant.BASE,
          title: "Need to report"
        };
      case AccountStatusVariant.Active:
        return {
          variant: BadgeVariant.SUCCESS,
          title: "Active"
        };
      case AccountStatusVariant.Unsubscribed:
        return {
          variant: BadgeVariant.BASE,
          title: "Unsubscribed"
        };
      case AccountStatusVariant.Rejected:
        return {
          variant: BadgeVariant.ERROR,
          title: "Rejected"
        };
      case AccountStatusVariant.PendingIDV:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending IDV",
          icon: (
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size={12}
              color="#DE9306"
            />
          )
        };
      case AccountStatusVariant.PendingOptIn:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending opt in",
          icon: (
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size={12}
              color="#DE9306"
            />
          )
        };
      case AccountStatusVariant.PendingOptOut:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending opt out",
          icon: (
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size={12}
              color="#DE9306"
            />
          )
        };
      case AccountStatusVariant.PendingLeaseVerification:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending lease verification",
          icon: (
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size={12}
              color="#DE9306"
            />
          )
        };
      case AccountStatusVariant.PendingLandlordVerification:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending landlord verification",
          icon: (
            <HugeiconsIcon
              icon={InformationCircleIcon}
              size={12}
              color="#DE9306"
            />
          )
        };
      default:
        return { variant: BadgeVariant.BASE, title: status };
    }
  }, [status]);

  return (
    <Badge
      className={cx("items-center min-w-0", className, "stroke-white")}
      size={size}
      variant={variant}
      leftElement={icon}
    >
      <span className="block overflow-hidden text-ellipsis whitespace-nowrap max-w-full">
        {title}
      </span>
    </Badge>
  );
};
